/**
 * v1.4.44 — User-controlled cover tile size.
 *
 * The user reported that focused tiles felt like they were resizing
 * uncontrollably. To give them direct control (independent of any
 * focus/hover CSS), we expose 3 presets that map to grid-column
 * counts. All Movies / Series / Search / Continue-Watching grids
 * read from this same value so the whole app scales consistently.
 *
 * Persisted in localStorage under `tv_player.tileSize`. Defaults to
 * "medium" (matches the prior behaviour — grid-cols-6 on TV, grid-
 * cols-7 on 2xl desktop).
 */
const KEY = "tv_player.tileSize";

export const TILE_SIZES = [
  { value: "small", label: "Small (more per row)" },
  { value: "medium", label: "Medium (default)" },
  { value: "large", label: "Large (fewer per row)" },
];

export function getTileSize() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "small" || v === "medium" || v === "large") return v;
  } catch { /* SSR / private-mode */ }
  return "medium";
}

export function setTileSize(v) {
  try {
    localStorage.setItem(KEY, v);
    // Broadcast so open Browse pages re-render without a refresh.
    window.dispatchEvent(new CustomEvent("tv_player:tileSize", { detail: v }));
  } catch { /* SSR / quota */ }
}

// Grid-column classes for each preset. TV layout is always fixed cols
// (no responsive breakpoints — Smart-TV WebViews report weird widths).
// The responsive layout scales up on larger viewports.
export function gridClassesFor(size, tvLayout) {
  if (tvLayout) {
    if (size === "small") return "grid-cols-8";
    if (size === "large") return "grid-cols-4";
    return "grid-cols-6"; // medium
  }
  if (size === "small") {
    return "grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-9 3xl:grid-cols-10";
  }
  if (size === "large") {
    return "grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6";
  }
  // medium (matches the old default)
  return "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 3xl:grid-cols-8";
}
